"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoverMediaQueryMixin = void 0;
var _styledComponents = require("styled-components");
/** @mixin hoverMediaQueryMixin */
/**
 * Wraps a CSS attributes string with a media query that targets devices
 * that have a hover event and use a pointer classified as "fine" such as a mouse.
 *
 * @example
 * import { hoverMediaQueryMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     color: black;
 *
 *     ${hoverMediaQueryMixin(`text-decoration: underline`)}
 * `;
 *
 * <Component />
 *
 * @method
 * @param {function|string} styles - The styles that should be applied at the given breakpoint.
 * @return {Interpolation}
 */
var hoverMediaQueryMixin = function hoverMediaQueryMixin(styles) {
  return (0, _styledComponents.css)(["@media (hover:hover) and (pointer:fine){&:hover:not(:disabled){", "}}"], typeof styles === 'function' ? styles() : styles);
};
exports.hoverMediaQueryMixin = hoverMediaQueryMixin;